import React from 'react';
import { withFormik, Form, Field } from 'formik';
import * as Yup from 'yup';
import SVGs from './SvgIcons';
// import axios from 'axios';
const phoneRegex =
	/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

function getParameterByName(name = 'agentid', url) {
	if (!url) url = window.location.href;
	name = name.replace(/[[\]]/g, '\\$&');
	var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
		results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

const ContactForm = ({ values, errors, touched, isSubmitting }) => (
	<Form>
		<div className="form-section__isolate">
			<label className="form-section__label" htmlFor="form__name">
				My Name is
				<span className="form-section__asterisk">*</span>
				{touched.name && errors.name && (
					<span className="form-section__warning">{errors.name}</span>
				)}
			</label>
			<Field
				className="form-section__input"
				type="name"
				name="name"
				id="form__name"
				placeholder="Name"
			/>
			{SVGs.user}
		</div>
		<div className="form-section__isolate">
			<label className="form-section__label" htmlFor="form__name">
				My Email is
				<span className="form-section__asterisk">*</span>
				{touched.email && errors.email && (
					<span className="form-section__warning">{errors.email}</span>
				)}
			</label>
			<Field
				className="form-section__input"
				type="email"
				name="email"
				id="form__name"
				placeholder="Email"
			/>
			{SVGs.email}
		</div>
		<div className="form-section__isolate">
			<label className="form-section__label" htmlFor="form__name">
				My Phone is
				<span className="form-section__asterisk">*</span>
				{touched.phoneNumber && errors.phoneNumber && (
					<span className="form-section__warning">{errors.phoneNumber}</span>
				)}
			</label>
			<Field
				className="form-section__input"
				type="text"
				name="phoneNumber"
				id="form__name"
				placeholder="Phone Number"
			/>
			{SVGs.phone}
		</div>
		<button
			type="submit"
			className="landing-section__button"
			disabled={isSubmitting}>
			Get My Report
		</button>
	</Form>
);

const FormikForm = withFormik({
	mapPropsToValues() {
		return {
			name: '',
			email: '',
			phoneNumber: '',
		};
	},
	validationSchema: Yup.object().shape({
		name: Yup.string()
			.min(2, 'Name must be at least 2 characters.')
			.required('Name is Required.'),
		email: Yup.string()
			.email('Email not Valid.')
			.required('Email is Required.'),
		phoneNumber: Yup.string()
			.matches(phoneRegex, 'Please enter valid phone number.')
			.required('Phone number required.'),
	}),

	async handleSubmit(values, { props, resetForm, setErrors, setSubmitting }) {
		const url = `/api/tools/rqanalyzer?agentid=${getParameterByName()}`;
		// console.log(url);
		const { answers, income } = props;
		const mapAnswersToObject = {
			answer1: answers[0],
			answer2: answers[1],
			answer3: answers[2],
			answer4: answers[3],
			answer5: answers[4],
			answer6: answers[5],
			answer7: answers[6],
			answer8: answers[7],
			answer9: answers[8],
			answer10: answers[9],
			answer11: answers[10],
			answer12: income,
		};
		const sendToAPI = {
			...values,
			...mapAnswersToObject,
			rqNumber: props.result,
		};
		// console.log('sendToAPI', JSON.stringify(sendToAPI));
		const response = await fetch(url, {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(sendToAPI),
		});
		// console.log('response', response);
		if (!response.ok) {
			console.log('POST failed');
			// add please try again here
			return;
		}
		// const json = await response.json();
		// console.log('json', json);
		// console.log(JSON.stringify(sendToAPI));
		props.onClick();

		// axios
		// 	.post('https://hooks.zapier.com/hooks/catch/1619863/j65tnp/', sendToAPI)
		// 	.then(() => {
		// 		setSubmitting(false);
		// 		resetForm();
		// 		props.onClick();
		// 	})
		// 	.catch(err => {
		// 		setSubmitting(false);
		// 		setErrors(err);
		// 		console.log(err);
		// 	});
		// console.log(JSON.stringify(sendToAPI));
		// props.onClick();
	},
})(ContactForm);

export default FormikForm;



// WEBPACK FOOTER //
// ./src/components/form/FormikForm.js